export const GET_ALL_CUSTOMER_ORDERS = 'GET_ALL_CUSTOMER_ORDERS'
export const GET_ALL_VENDOR_SELLING = 'GET_ALL_VENDOR_SELLING'
export const GET_ALL_VENDOR_SOLD = 'GET_ALL_VENDOR_SOLD'
export const GET_ALL_CUSTOMER_PAID = 'GET_ALL_CUSTOMER_PAID'
export const GET_ALL_CUSTOMER_UNPAID = 'GET_ALL_CUSTOMER_UNPAID'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
